
import { schema } from "./types";
import { IAutomationAppComponent } from "../../../types";
import { OverviewPanel, OperatorPanel, ParameterPanel } from '.';
import { IconUnderFloorHeating } from './IconUnderFloorHeating';
import InsightsPanel from "../../components/PlantInsights/InsightsPanel";
import InsightsSideviewPanel from "../../components/PlantInsights/InsightsSideviewPanel";


export const App: IAutomationAppComponent = {
    schema: schema,
    supportsProcessPanel: true,
    Icon: IconUnderFloorHeating,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ParameterPanel: ParameterPanel,
    InsightsPanel: InsightsPanel,
    SideViewPanel: InsightsSideviewPanel,
    createConfig: {
        group: "Plants",
        name: "Outlet for underfloor heatings / coolings",
        description: "Heating / Cooling outlet",
        panel: OverviewPanel,
        defaultState: {
            showFlow: 'true',
            showCoil: 'true',
            showTrendPanels: 'true',
        },
        defaultProperties: [
            { key: 'ShowFlow', value: 'true' },
            { key: 'ShowCoil', value: 'true' },
            { key: 'ShowTrendPanels', value: 'true' },
        ]
    },
}